/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-26 11:24:12
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2026-01-13 17:11:16
 * @FilePath: /qd-yunjing-web/src/router/modules/quality.ts
 * @Description: 这是默认设置,请设置`customMade`, BD%AE
 */
import { RouteRecordRaw } from 'vue-router';

import Layout from '@/layouts/index.vue';

export const safetyRoutes: RouteRecordRaw[] = [
  {
    path: '/quality',
    name: 'safety-root',
    component: Layout,
    meta: {
      authCodes: ['SAFETY'],
      title: '品质',
    },
    children: [
      {
        path: '/quality/map/index',
        name: 'safety-map-index',
        component: () => import('@/views/safety/map/index.vue'),
        meta: {
          authCodes: ['SECURITY_RISK_MAP'],
          title: '安全风险地图',
          keepAlive: true,
          activeMenu: '/quality',
        },
      },
      {
        path: '/quality/fireProrection',
        name: 'safety-fireProrection',
        meta: {
          authCodes: ['FIRE_PROTECTION'],
          title: '消防管理',
          keepAlive: true,
          activeMenu: '/quality',
        },
        children: [
          {
            path: '/fire-monitor/index',
            name: 'fire-monitor-index',
            component: () => import('@/views/ibms/fireProrection.vue'),
            meta: {
              authCodes: ['FIRE_MONITORING'],
              title: '消防检测',
              projectCheckStrictly: true,
              isThreeModel: true,
            },
          },
          {
            path: '/quality/fire/compartment',
            name: 'fireProrection-compartment',
            component: () => import('@/views/safety/fire/compartment.vue'),
            meta: {
              authCodes: ['FIRE_MAINTENANCE_MONITORING_FIRE_GROUP'],
              title: '消防分区',
              projectCheckStrictly: true,
              isThreeModel: true,
            },
          },
          {
            path: '/quality/manage/rule',
            name: 'safety-manage-rule',
            component: () => import('@/views/safety/alarm-config/normal-alarm.vue'),
            meta: {
              authCodes: ['FIRE_PROTECTION'],
              title: '告警规则',
              keepAlive: true,
              activeMenu: '/quality',
            },
          }
        ],
      },
      {
        path: '/quality/event/center',
        name: 'event-center',
        component: () => import('@/views/safety/eventcenter/index.vue'),
        meta: {
          authCodes: ['INSPECTION_EVENT_CENTER'],
          title: '巡检事件中心',
          keepAlive: true,
          activeMenu: '/quality',
          projectCheckStrictly: true,
          isThreeModel: true,
        },
      },
      {
        path: '/quality/duty',
        name: 'safety-duty',
        meta: {
          authCodes: ['INSPECTION_TASK'],
          title: '巡检任务',
          keepAlive: true,
          activeMenu: '/quality',
        },
        children: [
          {
            path: '/quality/duty/random',
            name: 'safety-duty-random',
            component: () => import('@/views/safety/random/index.vue'),
            meta: {
              authCodes: ['INSPECTION_TASK_RANDOM'],
              title: '随机巡检',
              keepAlive: true,
              activeMenu: '/quality',
              projectCheckStrictly: true,
              isThreeModel: true,
            },
          },
          {
            path: '/quality/duty/picture',
            name: 'safety-duty-picture',
            component: () => import('@/views/safety/duty/picture.vue'),
            meta: {
              authCodes: ['INSPECTION_TASK_PICTURE'],
              title: '云图像巡检',
              keepAlive: true,
              activeMenu: '/quality',
            },
          },
          {
            path: '/quality/duty/cloud',
            name: 'safety-duty-cloud',
            component: () => import('@/views/safety/duty/cloud.vue'),
            meta: {
              authCodes: ['INSPECTION_TASK_CLOUD'],
              title: '云督勤巡检',
              keepAlive: true,
              activeMenu: '/quality',
            },
          }
        ],
      },
      {
        path: '/quality/ai/index',
        name: 'safety-ai-index',
        component: () => import('@/views/safety/ai/index.vue'),
        meta: {
          authCodes: ['SAFETY_SCREEN'],
          title: 'AI场景管理',
          keepAlive: true,
          activeMenu: '/quality',
        },
      },
      {
        path: '/quality/ai/inspection',
        name: 'safety-ai-inspection',
        meta: {
          authCodes: ['INSPECTION_TASK_CONFIG'],
          title: '巡检任务配置',
          keepAlive: true,
          activeMenu: '/quality',
        },
        children: [
          {
            path: '/quality/ai/inspection/config',
            name: 'safety-ai-inspection-config',
            component: () => import('@/views/safety/ai/inspection.vue'),
            meta: {
              authCodes: ['INSPECTION_TASK_CONFIG'],
              // authCodes: ['SAFETY_RANDOM_CHECK'],
              title: 'AI巡检配置',
              keepAlive: true,
              activeMenu: '/quality',
            },
          },
          {
            path: '/quality/ai/config',
            name: 'safety-ai-config',
            component: () => import('@/views/safety/ai/config.vue'),
            meta: {
              authCodes: ['INSPECTION_TASK_CONFIG'],
              title: '远程巡检配置',
              keepAlive: true,
              activeMenu: '/quality',
            },
          }
        ],
      },

      {
        path: '/quality/report',
        name: 'quality-report',
        meta: {
          authCodes: ['SAFE_STATEMENT_ANALYSIS'],
          title: '报表分析',
          keepAlive: true,
          activeMenu: '/quality',
        },
        children: [
          {
            path: '/quality/report/ai-count',
            name: 'safety-report-ai-count',
            component: () => import('@/views/safety/report/ai-count.vue'),
            meta: {
              authCodes: ['REPORT_AI_COUNT'],
              title: 'AI统计',
              keepAlive: true,
              projectCheckStrictly: true,
              activeMenu: '/quality',
            },
          }
        ],
      }
    ],
  }
];
